import React from "react";
import { motion } from "framer-motion";

// School logos data - easily extendable
const schoolLogos = [
  {
    name: "Eton College",
    location: "Berkshire, UK",
    logo: "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/q8px4fkv_Eton%20College%20-%20Berkshire.jpg",
  },
  {
    name: "Bedford School",
    location: "Bedfordshire, UK",
    logo: "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/tty9coqu_Bedford-School-%20Bedforshire.png",
  },
  {
    name: "Cheltenham Ladies' College",
    location: "Gloucestershire, UK",
    logo: "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/3dzliwnn_Cheltenham%20Ladies%27%20College%20-%20Gloucestershire.jpg",
  },
  {
    name: "Dean Close St John's",
    location: "Chepstow, UK",
    logo: "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/bhez2sxj_Dean%20Close%20St%20John%E2%80%99s.jpg",
  },
  {
    name: "Ackworth School",
    location: "Yorkshire, UK",
    logo: "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/l44nrk2g_Ackworth%20School-%20Yorkshire.png",
  },
  {
    name: "Leighton Park School",
    location: "Reading, UK",
    logo: "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/fhxxvwut_Leighton%20Park%20School%20-%20Reading.jpg",
  },
  {
    name: "Tettenhall College",
    location: "West Midlands, UK",
    logo: "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/1yahewr4_Tettenhall%20College%20-%20The%20west%20Midlands.png",
  },
  {
    name: "National Mathematics & Science College",
    location: "West Midlands, UK",
    logo: "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/pli2gn0l_The%20National%20Mathematics%20And%20Science%20College%20-%20The%20west%20Midlands.png",
  },
  {
    name: "Whitgift School",
    location: "South Croydon, UK",
    logo: "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/80ly26s9_Whitgift%20School%20-%20South%20Croydon.png",
  },
];

const SchoolLogos = () => {
  // Duplicate logos for seamless infinite scroll
  const duplicatedLogos = [...schoolLogos, ...schoolLogos];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-[#FDFCF8] overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl mb-8 md:mb-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#C9A227] mb-3">
            Schools We Work With
          </p>
          <h2
            className="text-xl sm:text-2xl md:text-3xl font-medium text-[#1A202C] tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Trusted by Leading Boarding Schools Worldwide
          </h2>
        </motion.div>
      </div>

      {/* Infinite Scrolling Logo Carousel */}
      <div className="relative">
        {/* Gradient Overlays for fade effect */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-[#FDFCF8] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-[#FDFCF8] to-transparent z-10 pointer-events-none" />

        {/* Scrolling Container */}
        <div className="flex animate-scroll">
          {duplicatedLogos.map((school, index) => (
            <div
              key={`${school.name}-${index}`}
              className="flex-shrink-0 mx-4 sm:mx-6 md:mx-8 lg:mx-12"
              data-testid={`school-logo-${index}`}
            >
              <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-32 md:h-32 lg:w-36 lg:h-36 bg-white rounded-lg shadow-md border border-[#E2E8F0] flex items-center justify-center p-3 md:p-4 hover:shadow-lg hover:border-[#C9A227] transition-all duration-300 group">
                <img
                  src={school.logo}
                  alt={`${school.name} logo`}
                  className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                  loading="lazy"
                />
              </div>
              <p className="text-center text-xs text-[#4A5568] mt-2 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                {school.name}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* School count note */}
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="text-center text-[#4A5568] text-xs sm:text-sm mt-8 md:mt-10 italic px-4"
      >
        Working with 350+ schools across UK, USA, Switzerland, Singapore, Dubai & India
      </motion.p>
    </section>
  );
};

export default SchoolLogos;
